import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import { Col, Container, Row } from "reactstrap";
import styles from "./styles.module.scss";

export const SimpleFormWithBgImage = ({
  className,
  formId,
  successPageUrl,
  bgImage,
  backgroundColor,
  content,
  sectionId,
}) => {
  
  const backgroundStyle = bgImage?.url
    ? {
        backgroundImage: `url(${bgImage.url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : { backgroundColor: backgroundColor === "white" ? "#fff" : "#000" };

  const cleanSectionId = sectionId?.replace('#', '') || '';

  return (
    <section
      id={cleanSectionId}
      className={`${styles.root} ${className}`}
      style={backgroundStyle}
    >
      <Container className="position-relative">
        <Row>
          <Col md={6} className="pe-md-5 mb-4 mb-md-0">
            {content && (
              <div
                style={{ color: backgroundColor === "white" ? "black" : "white" }}
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </Col>
          <Col md={6} className="ps-md-5">
            {formId && (
              <div className={`p-5 rounded-4 formWrapper ${backgroundColor === "white" ? "primary-bg text-white" : "bg-white text-black"}`}>
                <SourceFlowForm
                  formId={formId}
                  onSubmitDone={() => (window.location.href = successPageUrl)}
                />
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default SimpleFormWithBgImage;